import { GetPaymentLinkRequest, SubscriptionDuration } from "@shared/types";
import { ValueOf } from "@shared/types/utils";
import { SUBSCRIPTION_QUERY_PARAMS } from "@shared/features/settings/subscription/constants";

export const DurationToSecondaryDisplay: Record<SubscriptionDuration, string> =
  {
    30: "Monthly",
    90: "Quarterly",
    180: "Half Yearly",
    360: "Annually",
  };

export const DurationToPrimaryDisplay: Record<SubscriptionDuration, string> = {
  30: "Month",
  90: "Quarter",
  180: "Half Year",
  360: "Year",
};

export enum BillingTab {
  CORNIX = "cornix",
  GROUPS = "groups",
}

export type SubscriptionQueryParams = ValueOf<typeof SUBSCRIPTION_QUERY_PARAMS>;

export type LocalStoragePaymentData = GetPaymentLinkRequest & {
  invoice_id: string;
  time_expires?: number;
};
